/**
 * Onboarding Service
 * API service for all onboarding-related operations
 */

import apiClient from '../../../../apiClient';

const BASE_URL = '/ta/onboarding';

export const onboardingService = {
  // Create onboarding from candidate (auto-populate)
  async createFromCandidate(candidateId) {
    try {
      const response = await apiClient.post(`${BASE_URL}/from-candidate/${candidateId}`);
      return response.data;
    } catch (error) {
      console.error(`Error creating onboarding from candidate ${candidateId}:`, error);
      throw error;
    }
  },

  // Get all onboarding records with optional filters
  async getAllOnboarding(filters = {}) {
    try {
      const params = new URLSearchParams(filters);
      const response = await apiClient.get(`${BASE_URL}?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching onboarding records:', error);
      throw error;
    }
  },

  // Get single onboarding record by ID
  async getOnboardingById(id) {
    try {
      const response = await apiClient.get(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching onboarding record ${id}:`, error);
      throw error;
    }
  },

  // Create manual onboarding record
  async createOnboarding(onboardingData) {
    try {
      const response = await apiClient.post(BASE_URL, onboardingData);
      return response.data;
    } catch (error) {
      console.error('Error creating onboarding record:', error);
      throw error;
    }
  },

  // Update onboarding record
  async updateOnboarding(id, onboardingData) {
    try {
      const response = await apiClient.put(`${BASE_URL}/${id}`, onboardingData);
      return response.data;
    } catch (error) {
      console.error(`Error updating onboarding record ${id}:`, error);
      throw error;
    }
  },

  // Delete onboarding record
  async deleteOnboarding(id) {
    try {
      const response = await apiClient.delete(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting onboarding record ${id}:`, error);
      throw error;
    }
  }
};

export default onboardingService;
